import { Pipe, PipeTransform } from '@angular/core';
import { RevenuePeriod } from '@vendasta/sales-orders';

@Pipe({ name: 'formatRevenuePeriod', standalone: true })
export class FormatRevenuePeriod implements PipeTransform {
  transform(value: RevenuePeriod, termLength: number): string {
    return formatRevenuePeriod(value, termLength);
  }
}

export function formatRevenuePeriod(value: RevenuePeriod, termLength: number): string {
  switch (value) {
    case RevenuePeriod.ONETIME:
      return 'EDIT_BILLING_TERMS_DIALOG.FORM.BILLING_FREQUENCY_ONE_TIME';
    case RevenuePeriod.YEARLY:
      if (termLength === 1) {
        return 'EDIT_BILLING_TERMS_DIALOG.FORM.BILLING_FREQUENCY_YEAR';
      } else return 'EDIT_BILLING_TERMS_DIALOG.FORM.BILLING_FREQUENCY_YEARS';
    default:
      if (termLength === 1) {
        return 'EDIT_BILLING_TERMS_DIALOG.FORM.BILLING_FREQUENCY_MONTH';
      } else return 'EDIT_BILLING_TERMS_DIALOG.FORM.BILLING_FREQUENCY_MONTHS';
  }
}
